import router from "@/router";
import { isToufang } from "./base";

export const calcScores = (scores) => {
    return +scores / 10
}

export function getParams() {
    const queryParams = {};
    const queryString = window.location.search.substring(1);
    const params = queryString.split('&');

    params.forEach(param => {
        const [key, value] = param.split('=');
        queryParams[key] = decodeURIComponent(value || '');
    });

    return queryParams;
}

export function getParam(key){
    return getParams()[key];
}

export const setStorage = (key, value) => {
    if(typeof value === "object" && value !== null){
        value = JSON.stringify(value)
    }
    localStorage.setItem(key, value);
}

export const getStorage = (key) => {
    return localStorage.getItem(key)
}

export const removeStorage = (key) => {
    localStorage.removeItem(key)
}

export const clearStorage = () => {
    localStorage.clear();
}

export const calcPrice = (price) => {
    return price / 100
}

export const isFacebookWebView = () => {
  const ua = window.navigator.userAgent;
  return /FB_IAB|FBAN|FBAV|FBWEBVIEW|FBANLITE/i.test(ua);
};

export const isTiktokWebView = () => {
    // 方法1：检查用户代理(UA)标识
  const userAgent = navigator.userAgent.toLowerCase();
  const isTikTokUA = /(tiktok)|(musically)|(bytedance)/i.test(userAgent);
  
  // 方法2：检查TikTok特有的JS对象（更可靠）
  const isTikTokEnv = typeof webview !== 'undefined' && 
                     webview?.name === 'TikTok';
  
  // 方法3：检查TikTok特有的URL参数
  const urlParams = new URLSearchParams(window.location.search);
  const hasTikTokParam = urlParams.has('tt_webid') || 
                         urlParams.has('tt_chain_token');
  
  return isTikTokUA || isTikTokEnv || hasTikTokParam;
}

export const isToufangWebView = () => {
    return isFacebookWebView() || isTiktokWebView();
}


export const isAndroid = () => {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    return isAndroid;
}

export const isIos = () => {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isiOS;
}

export const goToRouter = (path, query = {}) => {
    const obj = {}
    if(isToufangWebView() || getParam('ch')){
        obj.ch = '1'
    }
    const q = router.app.$route.query
    router.app.$router.push({
        path,
        query: {
            ...q,
            ...query,
            ...obj
        }
    })
}